module.exports = __webpack_public_path__ + "img/signature.dce009dd.svg";